import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';
import './style.scss';
import { tasksHost } from '../../../settings';
import { deleteTask, moveTask, openModal } from '../../../redux/actions';
import { Button, Icon } from '../../../components';
import colors from '../../../utils/colors';
import TaskPreviewModalLayout from '../../Modal/layouts/TaskPreview';

function TestEditorSingleTask({ id, task, index }) {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	const test = state.editor.test;

	//load image
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const taskImg = new Image();
	taskImg.src = `${tasksHost}/${task.swf.split('.swf')[0]}.png`;

	//calc image width
	const [taskImgSize, setImgSize] = useState(0);

	const handleRemove = (task) => {
		dispatch(deleteTask(task['id_pytania']));
	};

	const handleMove = (direction, index) => {
		if (direction === 'up') {
			if (index <= 0) {
				return;
			} else {
				let newTasks = test.tasks;
				const [removed] = newTasks.splice(index, 1);
				newTasks = [...newTasks.slice(0, index - 1), removed, ...newTasks.slice(index - 1)];
				dispatch(moveTask(newTasks));
			}
		} else if (direction === 'down') {
			if (index >= test.tasks) {
				return;
			} else {
				let newTasks = test.tasks;
				const [removed] = newTasks.splice(index, 1);
				newTasks = [...newTasks.slice(0, index + 1), removed, ...newTasks.slice(index + 1)];
				dispatch(moveTask(newTasks));
			}
		}
	};

	useEffect(() => {
		taskImg.addEventListener('load', function () {
			const imgSize = ((this.width / 1024) * 100).toFixed(0);
			if (imgSize > 100) {
				setImgSize(100);
			} else {
				setImgSize(imgSize);
			}
		});

		return () => {
			taskImg.removeEventListener('load', function () {
				const imgSize = ((this.width / 1024) * 100).toFixed(0);
				if (imgSize > 100) {
					setImgSize(100);
				} else {
					setImgSize(imgSize);
				}
			});
		};
	}, [taskImg]);

	const isTaskEditable = state.editor.mode === 'edit' && !state.app.isTabletSize;

	return (
		<Draggable draggableId={id} index={index} isDragDisabled={!isTaskEditable}>
			{(provided) => (
				<li
					id={id}
					className={`editor-task${isTaskEditable ? ' editable' : ''}`}
					{...provided.draggableProps}
					{...provided.dragHandleProps}
					ref={provided && provided.innerRef}
				>
					<div className="editor-task-body">
						<span className="task-number">{`${index + 1}.`}</span>
						<div className="editor-task-img">
							<img src={taskImg.src} alt="" style={{ width: `${taskImgSize}%` }} />
						</div>
					</div>
					<footer className="editor-task-footer">
						<div className="move-task-buttons">
							<Button color="primary" onClick={() => handleMove('up', index)}>
								<Icon name="chevron-up" width="14" height="14" color={colors.white} />
							</Button>
							<Button color="primary" onClick={() => handleMove('down', index)}>
								<Icon name="chevron-down" width="14" height="14" color={colors.white} />
							</Button>
						</div>
						<Button
							color="transparent"
							onClick={() => {
								dispatch(openModal(<TaskPreviewModalLayout image={taskImg} />, true));
							}}
						>
							<span className="btn-label desktop">Zobacz zadanie</span>
							<span className="btn-label mobile">Zobacz</span>
							<Icon name="eye" width="14" height="14" color={colors.black} />
						</Button>
						<Button
							color={`delete text-white`}
							className="editor-task-delete-btn"
							onClick={() => handleRemove(task)}
						>
							<Icon name="trash" width="14" height="14" color={colors.white} />
						</Button>
					</footer>
				</li>
			)}
		</Draggable>
	);
}

export default TestEditorSingleTask;
